import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FeatureFlags } from '~services/optimizely/feature-flags.enum';
import { OptimizelyService } from '~services/optimizely/optimizely.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private optimizelyService: OptimizelyService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isMaintenance = await this.optimizelyService.isFeatureEnabled(
      FeatureFlags.SiteMaintenance,
    );
    if (!isMaintenance) {
      return true;
    } else {
      this.router.navigate(['/error/unavailable']);
    }
  }
}
